var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListTemplate',{attrs:{"fields":_vm.fields,"update-action":_vm.isNotSystemRole,"delete-action":_vm.isNotSystemRole,"api-url":_vm.apiURL,"title":"Roles"}})}
var staticRenderFns = []

export { render, staticRenderFns }